import * as generalApi from '../../../general/api';

export function getCoverage(params) {
  return generalApi.getOsCoverage({ cloudType: 'rdc', ...params });
}

export function getCoverageCSV(params) {
  return generalApi.getOsCoverageCSV({ cloudType: 'rdc', ...params });
}
